import React from "react";
import { Link } from "react-router-dom";
import "../Styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-main">
        <div className="footer-logo-section">
          <div className="footer-logo">
            <img src="/Assets/Images/ut.png" alt="Logo" />
          </div>
          <div className="company-info">
            <p className="company-name">
              <strong>NM Universal Team</strong>
            </p>
          </div>
        </div>

        <div className="footer-content">
          <div className="footer-section">
            <h2>Hızlı Erişim</h2>
            <ul>
              <li>
                <Link to="/">Ana Sayfa</Link>
              </li>

              <li>
                <Link to="/ofislerimiz">Ofislerimiz</Link>
              </li>
              <li>
                <Link to="/iletisim">İletişim</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h2>İletişim</h2>
            <div
              className="contact-info"
              onClick={() => {
                window.location.href = "/iletisim";
              }}
            >
              <p>
                <i className="fa fa-envelope"></i>
                Destek ve İletişim
              </p>
              <p>
                <i className="fa fa-clock"></i>
                Pazartesi - Cuma
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-divider"></div>

      <div className="footer-bottom">
        <div className="footer-copyright">
          © {new Date().getFullYear()} <span>NM Universal Team</span>. Tüm
          Hakları Saklıdır. Powered by{" "}
          <a
            href="https://www.kodjet.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            KODJET YAZILIM
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
